<template>
    <span class="br-language-selector dropdown" id="language-header" >
        <a href="#" data-toggle="dropdown" data-hover="dropdown" data-close-others="true">
            <img :src="`/static/img/flags/${activeFlag}.png`" width="32" alt="flag-english">
        </a>
        <ul class="dropdown-menu">
            <li v-for="language in languages">
                <a href="#" class="flagSelector" @click="setLocale(language.locale)">
                    <img :src="`/static/img/flags/${language.country || language.locale}.png`" width="24" alt="flag-english"> <span>{{language.language}}</span></a>

            </li>
        </ul>
        <v-snackbar
                        :color="snackBarType"
                        :multi-line="mode === 'multi-line'"
                        :vertical="mode === 'vertical'"
                        v-model="snackBar"
                >
            <span style="font-size: 120%;">{{ snackBarMessage }}</span>
            <v-btn dark flat @click.native="snackBar = false">{{ $t('site.common.close') }}</v-btn>
        </v-snackbar>
    </span>
</template>

<script>
    let translationData = require('../lib/translation-data');
    import Vue from 'vue'
    import VueCookie from 'vue-cookie'
    import { switchLocale } from '../main'
    Vue.use(VueCookie);

    Vue.config.lang = VueCookie.get('locale') || 'en'
    console.log("Locale from cookie = " + Vue.config.lang);

    export default {
        name: "br-language-selector",
        data() {
            return {
                languages: translationData.getSelectableLanguages(),
                activeFlag: "us",
                snackBarMessage: "",
                snackBarType: "success",
                snackBar: false,
                mode: "multi-line",
            }
        },
        created() {
            this.setLocale( VueCookie.get('locale') || 'en');
        },
        methods: {
            setLocale: function (locale) {
                Vue.config.lang = locale;
                this.activeFlag = locale === "en" ? "us" : locale === "en-gb" ? "gb" : locale === 'cs' ? 'cz' : locale;
                //console.log(this.activeFlag , " is the flag");
                console.log( "process.env.DYNAMIC_LOCALE", process.env.DYNAMIC_LOCALE);

                switchLocale(locale).then( () => {
                    this.snackBarMessage = "Loaded Locale: " + locale + " successfully";
                    this.snackBarType = "success";

                    //this.snackBar = true;
                    this.$cookie.set('locale', locale);
                    this.$ga.event('ChangedLanguage', locale, "", "");
                }).catch( (err) => {
                    this.snackBarMessage = err.message || err;
                    this.snackBarType = "error";
                    this.snackBar = true;
                });
                //
                // if( process.env.DYNAMIC_LOCALE === "true") {
                //     if (locale !== 'en' && locale !== 'blank') {
                //         loadLanguageAsync(locale).then(( success ) => {
                //
                //             this.$i18n.locale = Vue.config.lang;
                //         }).catch(( err ) => {
                //
                //         })
                //     }
                //     else {
                //         try {
                //             // Vue.config.lang = locale;
                //             this.$cookie.set('locale', locale)
                //             this.$i18n.locale = Vue.config.lang;
                //             console.log("New locale = " + Vue.config.lang + ": language = ")
                //         }
                //         catch (err) {
                //             console.error(err || "undefined error..");
                //         }
                //     }
                // } else {
                //     this.$cookie.set('locale', locale);
                //     this.$i18n.locale = Vue.config.lang;
                //
                // }
            },
        }
    }
</script>

<style scoped>
    flagSelector. {
        padding-top:2px;
        padding-bottom:2px;
    }
    .br-language-selector {
        float: right;
        text-align: center;
        width: 35px;
        top: 25px;
        height: 45px;
        margin: 0px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/BRLanguageSelector.vue